import { observable, makeObservable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';
import actions from './actions';

export default class LanguageStore {
    version = '1.0';
    observed = {};

    constructor() {
        makeObservable(this, { observed: observable });
        withActions(this, actions);
    }
}

export function useLanguageStore() {
    const { store } = useStores();
    return store.languageStore;
}
